import type { AlertsSummaryQuery, ShadowServicesQuery } from './type';
export const alertsKey = {
  all: ['accesses', 'alerts'] as const,
  summary: (params?: AlertsSummaryQuery) => [...alertsKey.all, 'summary', params] as const,
  trendComparison: (params?: {
    year?: number;
    month?: number;
  }) => [...alertsKey.all, 'trend-comparison', params] as const,
  lists: () => [...alertsKey.all, 'list'] as const,
  list: (params: ShadowServicesQuery) => [...alertsKey.lists(), params] as const
} as const;